const articleList = document.querySelector('.article-card-list');
if (articleList) {
  /* ----------------------------------------
   * Helpers
   * ------------------------------------- */

  const getParent = (el) => el.closest('.sc-general');

  const getActiveFilters = (parent) => ({
    activeButtonValue: parent.querySelector('.mod-filter__button.is-active')?.dataset.slug || '',
    activeDropdownValue: parent.querySelector('.dropdown input:checked')?.dataset.slug || '',
  });

  const updateUrl = ({ activeButtonValue, activeDropdownValue, pageNumber }) => {
    const [baseUrl] = window.location.href.split('?');

    const params = new URLSearchParams();

    if (activeButtonValue) {
      params.set('filter', activeButtonValue);
    }

    if (activeDropdownValue) {
      if (activeDropdownValue !== 'all') {
        params.set('scope', activeDropdownValue);
      } else {
        params.delete('scope');
      }
    }

    if (pageNumber && pageNumber !== '1') {
      params.set('pageNumber', pageNumber);
    }

    const queryString = params.toString();
    window.history.pushState({}, '', queryString ? `${baseUrl}?${queryString}` : baseUrl);
  };

  /* ----------------------------------------
   * Axios
   * ------------------------------------- */

  const fetchArticleList = async ({ parent, activeButtonValue, activeDropdownValue, pageNumber = '' }) => {
    const action = parent.querySelector('[data-action]')?.value || 'getArticleList';

    const listInner = parent.querySelector('.article-card-list__inner');
    const pagination = parent.querySelector('.article-card-list__pagination');

    const { type, tenant, group, archive, key, kIndex, category } = getQueryConfig(parent);

    try {
      const { data } = await axios.post(localData.siteURL, {
        action,
        id: localData.id,
        pageNumber,
        filter: activeButtonValue,
        scope: activeDropdownValue,
        queryType: type,
        queryTenant: tenant,
        queryGroup: group,
        queryArchive: archive,
        kIndex: String(kIndex),
        key,
        category,
        nonce: await getNonceForAction(action),
      });

      if (listInner && data?.data?.html_list) {
        listInner.innerHTML = data.data.html_list;
      }

      if (pagination && data?.data?.html_pagination) {
        pagination.innerHTML = data.data.html_pagination;
      }

      updateUrl({ activeButtonValue, activeDropdownValue, pageNumber });
      articleList.scrollIntoView();
    } catch (error) {
      console.error(error);
    }
  };

  /* ----------------------------------------
   * Event Handlers
   * ------------------------------------- */

  const handleFilterChange = (ev, { toggleActiveButton = false } = {}) => {
    ev.preventDefault();

    const parent = getParent(ev.target);

    if (toggleActiveButton) {
      parent.querySelector('.mod-filter__button.is-active')?.classList.remove('is-active');
      ev.target.classList.add('is-active');
    }

    const { activeButtonValue, activeDropdownValue } = getActiveFilters(parent);
    const pageNumber = ev.target.dataset.page || '';

    fetchArticleList({
      parent,
      activeButtonValue,
      activeDropdownValue,
      pageNumber,
    });
  };

  const getQueryConfig = (parent) => {
    const inner = parent.querySelector('.article-card-list__settings');

    return {
      type: inner?.dataset.queryType ?? '',
      tenant: inner?.dataset.queryTenant ?? '',
      group: inner?.dataset.queryGroup === 'true',
      archive: inner?.dataset.queryArchive === 'true',
      key: inner?.dataset.queryKey ?? '',
      kIndex: inner?.dataset.queryKIndex ?? '',
      category: inner?.dataset.queryCategory ?? '',
    };
  };

  /* ----------------------------------------
   * Events
   * ------------------------------------- */

  // Filter buttons
  attachEvent('.article-card-list .mod-filter__button', 'click', (ev) =>
    handleFilterChange(ev, { toggleActiveButton: true }),
  );

  // Search button
  attachEvent('.article-card-list .mod-filter .btn', 'click', handleFilterChange);

  // Pagination
  attachEvent(
    '.article-card-list .page-numbers, .content-module__pagination .page-numbers',
    'click',
    handleFilterChange,
  );
}
